import { useState } from 'react'
import { formatNumber } from '../../../../../utility'
import { round } from 'lodash'
import { ChevronDownIcon } from '@heroicons/react/24/solid'
import { ChevronUpIcon } from '@heroicons/react/24/outline'

type Props = {
  title: string
  value: number
  bold?: boolean
  suffix?: string
  indent?: boolean
  doRound?: boolean
  children?: React.ReactNode
  subItem?: boolean
  subtitle?: string
}

const Item: React.FC<Props> = ({ title, value, bold, suffix = '', indent = false, doRound = false, children, subItem = false, subtitle }) => {
  const [show, setShow] = useState(false)

  const getNumber = (): string => {
    if (doRound) {
      return `${formatNumber(round(value))}${suffix}`
    }
    return `${formatNumber(value)}${suffix}`
  }

  const toggle = () => {
    if (!!children) {
      setShow(!show)
    }
  }

  const getCaret = () => {
    if (!!children) {
      if (show) {
        return <ChevronUpIcon className="w-4 h-4" />
      }
      return <ChevronDownIcon className="w-4 h-4" />
    }
    return null
  }

  return (
    <div>
      <div className={`flex justify-between ${children && 'cursor-pointer'}`} onClick={toggle}>
        <div
          className={`${!!subItem && 'ml-5'} flex gap-1 items-center ${subtitle ? 'w-1/3' : 'w-2/4'} ${bold && 'font-bold'} ${
            children && 'hover:underline'
          } ${indent && 'pl-5'}`}
        >
          {getCaret()}
          {title}
        </div>
        {subtitle && <div className="w-1/3">{subtitle}</div>}
        <div className={`${subtitle ? 'w-1/3' : 'w-2/4'} ${bold && 'font-bold'}`}>{getNumber()}</div>
      </div>
      {show && <div>{children}</div>}
    </div>
  )
}

export default Item
